import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'web-ui-components/lib/organisms/modals';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';

export const CommonModal = ({
  brandID,
  header,
  infoCardContent,
  onRequestClose,
  secondaryBtnName,
  primaryBtnName,
  isOpen,
  onPrimaryBtnClick,
  showSecondaryButton,
}) => {
  const Footer = (
    <NavigationButtonGroup
      primaryButton={
        <NavigationButton.Primary labelText={primaryBtnName} onClick={onPrimaryBtnClick} />
      }
      secondaryButtons={
        showSecondaryButton && (
          <NavigationButton.Secondary labelText={secondaryBtnName} onClick={onRequestClose} />
        )
      }
    />
  );
  const close = <NavigationButton.Tertiary labelText="Close" onClick={onRequestClose} />;

  return (
    <Modal
      header={close}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick
      size="md"
      title={header}
      footer={Footer}
    >
      {brandID === 'VM' ? (
        <div>
          <span>{infoCardContent}</span>
        </div>
      ) : (
        <Card bordered type="warning">
          {infoCardContent}
        </Card>
      )}
    </Modal>
  );
};

CommonModal.defaultProps = {
  header: "Sorry, there's been a technical problem",
  infoCardContent:
    "It looks like something has gone wrong in the background. Please try again. If you're still having problems get in touch.",
  primaryBtnName: 'Retry',
  secondaryBtnName: 'Close',
  showSecondaryButton: true,
};

CommonModal.propTypes = {
  brandID: PropTypes.string,
  header: PropTypes.string,
  infoCardContent: PropTypes.string,
  primaryBtnName: PropTypes.string,
  secondaryBtnName: PropTypes.string,
  onRequestClose: PropTypes.func,
  isOpen: PropTypes.bool,
  onPrimaryBtnClick: PropTypes.func,
  showSecondaryButton: PropTypes.bool,
};
